const base = '/transactions'
const TransactionsApi = {
  base,
  fileUpload:  base+ '/upload'
};

export default TransactionsApi;
